exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Burst__burst{width:100vw;height:100vh;overflow:hidden}", ""]);

// exports
exports.locals = {
	"burst": "Burst__burst"
};